import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
    AppUserPasswordSetupTokenListItem,
    AppUserPasswordSetupTokenListRequest,
    AppUserPasswordSetupTokenListResponse,
} from 'core/models';
import { ApiListDataService } from './api.list-data.service';

@Injectable({
    providedIn: 'root',
})
export class ApiAppUserPasswordSetupTokensService extends ApiListDataService<
    AppUserPasswordSetupTokenListItem,
    AppUserPasswordSetupTokenListItem
> {
    constructor(http: HttpClient) {
        super(http, '/User/');
    }

    public getTokens(
        model: AppUserPasswordSetupTokenListRequest,
    ): Observable<AppUserPasswordSetupTokenListResponse> {
        return this.get<AppUserPasswordSetupTokenListResponse>('AppUserPasswordSetupTokens', {
            ...model,
        });
    }
}
